module.exports = __webpack_public_path__ + "static/img/ecommerce-300x300.b6adf246.jpg";